module.exports = __webpack_public_path__ + "static/media/spain-final1.b15c5dd6.png";